import { createReducer } from 'reduxsauce';
import { Types } from './types';
import { INITIAL_STATE } from './initialState';

export const recipientsStart = state => ({
  ...state,
  isLoading: true,
  error: null,
});

export const recipientsSuccess = (state, { data }) => ({
  ...state,
  data,
  isLoading: false,
});

export const recipientsError = (state, { error }) => ({
  ...state,
  error,
  isLoading: false,
});

export const nonProfitSuccess = (state, { data }) => ({
  ...state,
  nonProfitData: data,
  isLoading: false,
});

export const nonProfitError = (state, { error }) => ({
  ...state,
  nonProfitError: error,
  isLoading: false,
});

export const recipientsCleanUp = state => ({
  ...state,
  nonProfitError: null,
  nonProfitData: null,
  isLoading: false,
});

export const recipientsFinishLoading = state => ({
  ...state,
  isLoading: false,
});

export const HANDLERS = {
  [Types.RECIPIENTS_START]: recipientsStart,
  [Types.RECIPIENTS_SUCCESS]: recipientsSuccess,
  [Types.RECIPIENTS_ERROR]: recipientsError,
  [Types.RECIPIENTS_CLEAN_UP]: recipientsCleanUp,
  [Types.NON_PROFIT_SUCCESS]: nonProfitSuccess,
  [Types.NON_PROFIT_ERROR]: nonProfitError,
};

export default createReducer(INITIAL_STATE, HANDLERS);
